import React, { Component } from 'react';
import { get } from 'lodash';
import { Modal, ModalHeader, ModalBody } from '../common/modal/Modal';
import { withModelInfo } from '../common/ModelInfoContext';

class AdChoices extends Component {
  constructor(props) {
    super(props);
    this.receiveMessage = this.receiveMessage.bind(this);
  }

  onClose = () => {
    const { history, match } = this.props;
    history.push(`/${match.params.parent}`);
  };

  receiveMessage(event) {
    if (get(event, 'data') === 'close') {
      this.props.onClose();
    }
  }

  componentDidMount() {
    window.addEventListener('message', this.receiveMessage, false);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.receiveMessage, false);
  }

  render() {
    const { modelInfo } = this.props;

    return (
      <Modal isOpen={true} onRequestClose={this.onClose}>
        <ModalHeader onClose={this.onClose} />
        <ModalBody>
          <iframe
            src={modelInfo.adChoicesUrl}
            className="modal-body__content"
            style={{ width: '100%', height: '450px' }}
          />
        </ModalBody>
      </Modal>
    );
  }
}

export default withModelInfo(AdChoices);
